import { render, staticRenderFns } from "./CreateApPayments.vue?vue&type=template&id=4c7940e0&"
import script from "./CreateApPayments.vue?vue&type=script&lang=ts&"
export * from "./CreateApPayments.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/agent/workspace/SPP/deployment/frontend-erp-spp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4c7940e0')) {
      api.createRecord('4c7940e0', component.options)
    } else {
      api.reload('4c7940e0', component.options)
    }
    module.hot.accept("./CreateApPayments.vue?vue&type=template&id=4c7940e0&", function () {
      api.rerender('4c7940e0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/account-payables/ap-payments/CreateApPayments.vue"
export default component.exports